import React, { useEffect, useState } from 'react'
import {
    treatment4,
} from "../../../utils/DoctorData";
import { HashLink } from 'react-router-hash-link';

export default function Periodontists() {
    const treatments = [
        { id: "Endodontists", data: treatment4 },

    ];
    const [isHeaderFixed, setIsHeaderFixed] = useState(true);
    const [prevScrollPos, setPrevScrollPos] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.scrollY;
            setIsHeaderFixed(
                currentScrollPos < prevScrollPos && currentScrollPos > 0
            );
            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [prevScrollPos]);
    useEffect(() => {
        window.scrollTo(0, 0); // Ensures the page scrolls to the top on mount
    }, []);
    return (
        <div className='font-poppins pt-[100px] lg:pt-[130px] pb-[60px]'>
            <div className=" lg:hidden block grid bg-[#B1F4F4] grid-cols-4 x-5 py-[7%] text-[#35373A] font-medium text-[12px] z-9">
                <HashLink className="flex flex-col justify-between items-center"
                    to="/treatment/pedodontists"
                >
                    <svg
                        id="tooth"
                        fill="#35373A"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-[32%] mt-[5%]"
                        viewBox="0 0 133.147 113.819"
                    >
                        <g
                            id="Group_27610"
                            data-name="Group 27610"
                            transform="translate(25.77 32.213)"
                        >
                            <g id="Group_27609" data-name="Group 27609">
                                <path
                                    id="Path_37941"
                                    data-name="Path 37941"
                                    d="M100.3,156.719V156H96v.719c0,1.231.032,2.461.094,3.685l4.291-.219C100.327,159.032,100.3,157.879,100.3,156.719Z"
                                    transform="translate(-96 -156)"
                                />
                            </g>
                        </g>
                        <g
                            id="Group_27612"
                            data-name="Group 27612"
                            transform="translate(26.23 40.558)"
                        >
                            <g id="Group_27611" data-name="Group 27611">
                                <path
                                    id="Path_37942"
                                    data-name="Path 37942"
                                    d="M101.979,187.088l-4.267.487a71.819,71.819,0,0,0,10.9,30.57l3.612-2.324A67.554,67.554,0,0,1,101.979,187.088Z"
                                    transform="translate(-97.712 -187.088)"
                                />
                            </g>
                        </g>
                        <g
                            id="Group_27614"
                            data-name="Group 27614"
                            transform="translate(51.586 11.193)"
                        >
                            <g id="Group_27613" data-name="Group 27613">
                                <path
                                    id="Path_37943"
                                    data-name="Path 37943"
                                    d="M219.742,77.7a22.551,22.551,0,0,1-25.171,0l-2.4,3.561a26.85,26.85,0,0,0,29.977,0Z"
                                    transform="translate(-192.168 -77.696)"
                                />
                            </g>
                        </g>
                        <g
                            id="Group_27616"
                            data-name="Group 27616"
                            transform="translate(0 73.016)"
                        >
                            <g id="Group_27615" data-name="Group 27615">
                                <path
                                    id="Path_37944"
                                    data-name="Path 37944"
                                    d="M19.328,308h-4.3A15.052,15.052,0,0,1,0,323.033v4.3A15.052,15.052,0,0,1,15.033,342.36h4.3A15.052,15.052,0,0,1,34.36,327.328v-4.3A15.052,15.052,0,0,1,19.328,308ZM17.18,333.545a19.422,19.422,0,0,0-8.365-8.365,19.423,19.423,0,0,0,8.365-8.365,19.423,19.423,0,0,0,8.365,8.365A19.422,19.422,0,0,0,17.18,333.545Z"
                                    transform="translate(0 -308)"
                                />
                            </g>
                        </g>
                        <g
                            id="Group_27618"
                            data-name="Group 27618"
                            transform="translate(17.18 0)"
                        >
                            <g id="Group_27617" data-name="Group 27617">
                                <path
                                    id="Path_37945"
                                    data-name="Path 37945"
                                    d="M164.934,53.18h-4.113A27.43,27.43,0,0,0,135.517,36a26.271,26.271,0,0,0-14.483,4.164,14.006,14.006,0,0,1-15.282,0A26.261,26.261,0,0,0,91.269,36,27.3,27.3,0,0,0,64,63.269v5.663a79.971,79.971,0,0,0,12.728,43.331,75.711,75.711,0,0,1,9.78,22.613l2.337,9.35a7.378,7.378,0,0,0,14.455-.694l4.817-32.123a5.335,5.335,0,0,1,10.551,0l4.817,32.123a7.379,7.379,0,0,0,14.457.694l2.339-9.35a75.669,75.669,0,0,1,9.782-22.613A80.761,80.761,0,0,0,160.63,87.317c0,.075.009.148.009.223h4.3a15.052,15.052,0,0,1,15.033-15.033v-4.3A15.052,15.052,0,0,1,164.934,53.18Zm-18.486,56.759a80,80,0,0,0-10.334,23.9l-2.341,9.35a3.082,3.082,0,0,1-6.039-.292l-4.817-32.123a9.631,9.631,0,0,0-19.049,0L99.052,142.9a3.085,3.085,0,0,1-6.043.292l-2.339-9.35a79.9,79.9,0,0,0-10.334-23.9A75.7,75.7,0,0,1,68.3,68.932V63.269A23,23,0,0,1,91.269,40.3a21.965,21.965,0,0,1,12.123,3.46,18.253,18.253,0,0,0,20,0,21.978,21.978,0,0,1,12.125-3.46A23.055,23.055,0,0,1,158.234,59.76l.09,1.4a15.024,15.024,0,0,1-12.718,7.055v4.3a15.011,15.011,0,0,1,12.23,6.324A76.3,76.3,0,0,1,146.448,109.939Zm16.338-31.214a19.422,19.422,0,0,0-8.365-8.365A19.422,19.422,0,0,0,162.786,62a19.422,19.422,0,0,0,8.365,8.365A19.422,19.422,0,0,0,162.786,78.725Z"
                                    transform="translate(-64 -36)"
                                />
                            </g>
                        </g>
                    </svg>
                    <p className=" mt-[6px]">Pedodontist</p>
                </HashLink>
                <HashLink className="flex flex-col justify-between items-center"
                    to="/treatment/orthodontists"
                >
                    <svg
                        fill="#35373A"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-[28%]"
                        viewBox="0 0 106.246 123.234"
                    >
                        <g
                            id="dental-care_1_"
                            data-name="dental-care (1)"
                            transform="translate(0)"
                        >
                            <path
                                id="Path_37936"
                                data-name="Path 37936"
                                d="M60.458,33.357A1.805,1.805,0,1,0,59.43,29.9,18.9,18.9,0,0,0,51.027,35c-6.209,6.6-5.1,15.479-4.819,17.192A1.805,1.805,0,1,0,49.77,51.6c-.236-1.419-1.156-8.766,3.887-14.125A15.36,15.36,0,0,1,60.458,33.357Zm40.1-9.2a6.077,6.077,0,0,0,0,8.535l4.686,4.686a7.453,7.453,0,0,0,10.529,0l13.208-13.208a6.036,6.036,0,1,0-8.62-8.451l-9.853,9.853L109.1,24.157A6.084,6.084,0,0,0,100.562,24.157Zm9.95,5.423a2.633,2.633,0,0,0,1.875-.777l10.531-10.531a2.514,2.514,0,0,1,3.426-.167,2.448,2.448,0,0,1,.087,3.511L113.223,34.824a3.842,3.842,0,0,1-5.422,0l-4.685-4.686a2.424,2.424,0,1,1,3.429-3.428l2.093,2.093a2.634,2.634,0,0,0,1.874.776ZM116.479,0a1.806,1.806,0,0,0-.228,3.6,23.143,23.143,0,1,1-7.842.843,1.805,1.805,0,1,0-.994-3.471A26.906,26.906,0,0,0,88.291,22.914a42.859,42.859,0,0,1-4.682,3.012,7.916,7.916,0,0,1-7.071.379,23.58,23.58,0,0,1-4.96-2.974c-2.641-1.892-5.372-3.849-9.5-4.151A24.942,24.942,0,0,0,46.8,23.667c-6.374,4.291-10.511,12.107-11.35,21.443a35.062,35.062,0,0,0,.882,12.018,40.3,40.3,0,0,0,3.037,7.448,40.924,40.924,0,0,1,2.69,6.373c1.262,4.309,1.1,8.589.933,13.12-.062,1.67-.127,3.4-.117,5.14.054,9.953.122,22.339,8.058,29.5,3.165,2.854,8.208,5.842,12.329,3.9,3.043-1.43,3.518-4.626,4.177-9.047a82,82,0,0,1,1.62-8.512c.2-.774.393-1.619.6-2.514.287-1.229.721-2.981-1.054-3.4-1.738-.409-2.163,1.295-2.463,2.578-.2.878-.4,1.706-.586,2.447a85.042,85.042,0,0,0-1.691,8.868c-.589,3.955-.9,5.729-2.141,6.311-2.006.942-5.812-1.006-8.375-3.318-6.753-6.089-6.816-17.591-6.866-26.834-.01-1.665.054-3.352.115-4.984.173-4.62.351-9.4-1.076-14.27a44.294,44.294,0,0,0-2.911-6.943,37.058,37.058,0,0,1-2.788-6.774,31.475,31.475,0,0,1-.779-10.783c.742-8.249,4.3-15.091,9.771-18.772a21.285,21.285,0,0,1,13-3.881c3.113.228,5.22,1.738,7.659,3.485A26.756,26.756,0,0,0,75.2,29.658a11.5,11.5,0,0,0,10.03-.5,25.9,25.9,0,0,0,2.8-1.667,26.765,26.765,0,0,0,32.524,25.355,29.021,29.021,0,0,1-3.2,9.7c-4.241,7.681-4.153,14.833-4.06,22.4.017,1.377.035,2.8.027,4.256-.053,9.239-.118,20.738-6.869,26.825-2.562,2.312-6.368,4.26-8.373,3.317-1.24-.583-1.553-2.356-2.142-6.312a85.08,85.08,0,0,0-1.691-8.867c-1.518-5.986-3.988-17.546-10.454-20.942a8.187,8.187,0,0,0-6.977-.293c-3.367,1.279-5.959,4.311-7.924,9.268a1.806,1.806,0,0,0,3.357,1.331c1.571-3.962,3.484-6.324,5.851-7.223a4.661,4.661,0,0,1,4.016.115C87,88.986,89.447,99.939,90.743,105.05a82.052,82.052,0,0,1,1.62,8.512c.659,4.422,1.134,7.617,4.177,9.048,4.174,1.962,9.189-1.073,12.328-3.9,7.934-7.154,8-19.536,8.061-29.5.008-1.477-.01-2.918-.027-4.311-.091-7.389-.17-13.77,3.61-20.615a33.169,33.169,0,0,0,3.818-12.577A26.761,26.761,0,0,0,116.479,0ZM49.043,56.948a1.806,1.806,0,0,0-1.66,1.94,19.585,19.585,0,0,0,.495,3.1A1.806,1.806,0,0,0,49.63,63.37a1.826,1.826,0,0,0,1.756-2.233,15.976,15.976,0,0,1-.4-2.529A1.805,1.805,0,0,0,49.043,56.948Z"
                                transform="translate(-35.29 0)"
                            />
                        </g>
                    </svg>
                    <p className="mt-[6px]">Orthodontist</p>
                </HashLink>
                <HashLink className="flex flex-col justify-between items-center"
                    to="/treatment/periodontists"
                >
                    <svg
                        fill="#35373A"
                        id="g771"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-[28%] mt-[5%]"
                        viewBox="0 0 123.234 123.234"
                    >
                        <defs>
                            <clipPath id="clip-path">
                                <path
                                    id="path777"
                                    d="M0-682.665H123.234v123.234H0Z"
                                    transform="translate(0 682.665)"
                                />
                            </clipPath>
                        </defs>
                        <g id="g773" transform="translate(0 0)">
                            <g id="g775" clip-path="url(#clip-path)">
                                <g id="g781" transform="translate(6.971 17.459)">
                                    <path
                                        id="path783"
                                        d="M-49.128,9.948a1.82,1.82,0,0,1-.261-.019,1.805,1.805,0,0,1-1.528-2.045,34.066,34.066,0,0,1,7.8-17.251,1.805,1.805,0,0,1,2.545-.2,1.805,1.805,0,0,1,.2,2.545A30.46,30.46,0,0,0-47.344,8.4,1.806,1.806,0,0,1-49.128,9.948Z"
                                        transform="translate(50.936 10)"
                                    />
                                </g>
                                <g id="g785" transform="translate(20.782 6.105)">
                                    <path
                                        id="path787"
                                        d="M-424.187-132.317a1.806,1.806,0,0,1-1.785-1.549,30.393,30.393,0,0,0-30.023-26.189,30.32,30.32,0,0,0-13.644,3.063,16.348,16.348,0,0,1-14.479.033,30.4,30.4,0,0,0-13.739-3.1,30.549,30.549,0,0,0-16.948,5.28,1.805,1.805,0,0,1-2.508-.477,1.805,1.805,0,0,1,.477-2.508,34.148,34.148,0,0,1,18.944-5.905,33.9,33.9,0,0,1,15.286,3.426,12.764,12.764,0,0,0,11.316.036,33.985,33.985,0,0,1,15.328-3.462A33.982,33.982,0,0,1-422.4-134.378a1.805,1.805,0,0,1-1.531,2.043A1.821,1.821,0,0,1-424.187-132.317Z"
                                        transform="translate(517.626 163.667)"
                                    />
                                </g>
                                <g id="g789" transform="translate(50.474 41.961)">
                                    <path
                                        id="path791"
                                        d="M21.765-178.549h-.107a11.767,11.767,0,0,1-11.479-11c-.829-12.02-3.358-29.379-4.2-32.48-.664-2.449-2.063-5.368-4.958-5.368-2.305,0-3.974,1.809-4.96,5.376-.523,1.889-1.538,7.421-2.468,14.342a1.805,1.805,0,0,1-2.03,1.549,1.805,1.805,0,0,1-1.549-2.03A145.175,145.175,0,0,1-7.418-222.98c1.43-5.174,4.427-8.024,8.44-8.024,4.04,0,7.038,2.853,8.442,8.033,1,3.675,3.508,21.457,4.317,33.177a8.139,8.139,0,0,0,7.911,7.635c5.554.052,7.553-5.886,8.154-8.442,2.216-9.42,5.3-21.4,8.923-34.634a21.25,21.25,0,0,1,5.075-9.019A30.7,30.7,0,0,0,52.105-252.1a1.805,1.805,0,0,1,1.985-1.606,1.805,1.805,0,0,1,1.606,1.985,34.331,34.331,0,0,1-9.236,19.957,17.628,17.628,0,0,0-4.208,7.483c-3.61,13.2-6.684,25.13-8.891,34.508C31.7-182.737,27.374-178.549,21.765-178.549Z"
                                        transform="translate(10.001 253.717)"
                                    />
                                </g>
                                <g id="g793" transform="translate(6.807 41.913)">
                                    <path
                                        id="path795"
                                        d="M23.942,65.108c-5.385,0-9.94-4.018-11.336-10C10.041,44.112,6.892,31.8,3.5,19.493A17.6,17.6,0,0,0-.714,12.037,34.323,34.323,0,0,1-9.991-8.009,1.805,1.805,0,0,1-8.382-9.991,1.805,1.805,0,0,1-6.4-8.382,30.7,30.7,0,0,0,1.9,9.544a21.226,21.226,0,0,1,5.081,8.988c3.406,12.35,6.568,24.713,9.143,35.754.837,3.59,3.58,7.211,7.82,7.211h.007c4.208,0,7.611-3.461,7.917-8.041.2-3.011.473-6.175.81-9.4a1.805,1.805,0,0,1,3.591.374c-.332,3.185-.6,6.3-.8,9.271-.433,6.5-5.384,11.4-11.516,11.411Z"
                                        transform="translate(10.001 10.001)"
                                    />
                                </g>
                                <g id="g797" transform="translate(77.618 34.247)">
                                    <path
                                        id="path799"
                                        d="M33.812-6.39H-8.195A1.805,1.805,0,0,1-10-8.195,1.805,1.805,0,0,1-8.195-10H33.812a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1,33.812-6.39Z"
                                        transform="translate(10 10)"
                                    />
                                </g>
                                <g id="g801" transform="translate(0 34.247)">
                                    <path
                                        id="path803"
                                        d="M33.89-6.39H-8.195A1.805,1.805,0,0,1-10-8.195,1.805,1.805,0,0,1-8.195-10H33.89A1.805,1.805,0,0,1,35.7-8.195,1.805,1.805,0,0,1,33.89-6.39Z"
                                        transform="translate(10 10)"
                                    />
                                </g>
                                <g id="g805" transform="translate(0 41.482)">
                                    <path
                                        id="path807"
                                        d="M-199.241-6.39h-42.085a1.805,1.805,0,0,1-1.805-1.805A1.805,1.805,0,0,1-241.326-10h42.085a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1-199.241-6.39Z"
                                        transform="translate(243.131 10)"
                                    />
                                </g>
                                <g id="g809" transform="translate(77.618 41.482)">
                                    <path
                                        id="path811"
                                        d="M-84.543-6.39h-16.818a1.805,1.805,0,0,1-1.805-1.805A1.805,1.805,0,0,1-101.361-10h16.818a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1-84.543-6.39Z"
                                        transform="translate(103.166 10)"
                                    />
                                </g>
                                <g id="g813" transform="translate(102.899 41.482)">
                                    <path
                                        id="path815"
                                        d="M-84.119-6.39h-16.725a1.805,1.805,0,0,1-1.805-1.805A1.805,1.805,0,0,1-100.844-10h16.725a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1-84.119-6.39Z"
                                        transform="translate(102.649 10)"
                                    />
                                </g>
                                <g id="g817" transform="translate(42.447 24.359)">
                                    <path
                                        id="path819"
                                        d="M-30.048-10h25.1A6.627,6.627,0,0,1,1.673-3.381V14a6.627,6.627,0,0,1-6.619,6.619h-25.1A6.627,6.627,0,0,1-36.667,14V-3.381A6.627,6.627,0,0,1-30.048-10Zm25.1,27.012A3.012,3.012,0,0,0-1.937,14V-3.381A3.012,3.012,0,0,0-4.946-6.39h-25.1a3.012,3.012,0,0,0-3.009,3.009V14a3.012,3.012,0,0,0,3.009,3.009Z"
                                        transform="translate(36.667 10)"
                                    />
                                </g>
                                <g id="g821" transform="translate(67.409 37.865)">
                                    <path
                                        id="path823"
                                        d="M1.091-6.39H-8.195A1.805,1.805,0,0,1-10-8.195,1.805,1.805,0,0,1-8.195-10H1.091A1.805,1.805,0,0,1,2.9-8.195,1.805,1.805,0,0,1,1.091-6.39Z"
                                        transform="translate(10 10)"
                                    />
                                </g>
                                <g id="g825" transform="translate(42.447 37.865)">
                                    <path
                                        id="path827"
                                        d="M8.326-6.39H-8.195A1.805,1.805,0,0,1-10-8.195,1.805,1.805,0,0,1-8.195-10H8.326a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1,8.326-6.39Z"
                                        transform="translate(10 10)"
                                    />
                                </g>
                                <g id="g829" transform="translate(49.441 31.112)">
                                    <path
                                        id="path831"
                                        d="M-5.783-6.39H-8.195A1.805,1.805,0,0,1-10-8.195,1.805,1.805,0,0,1-8.195-10h2.412A1.805,1.805,0,0,1-3.978-8.195,1.805,1.805,0,0,1-5.783-6.39Z"
                                        transform="translate(10 10)"
                                    />
                                </g>
                                <g id="g833" transform="translate(49.441 44.738)">
                                    <path
                                        id="path835"
                                        d="M-5.783-6.39H-8.195A1.805,1.805,0,0,1-10-8.195,1.805,1.805,0,0,1-8.195-10h2.412A1.805,1.805,0,0,1-3.978-8.195,1.805,1.805,0,0,1-5.783-6.39Z"
                                        transform="translate(10 10)"
                                    />
                                </g>
                                <g id="g837" transform="translate(67.771 31.112)">
                                    <path
                                        id="path839"
                                        d="M-19.144-6.39h-2.412a1.805,1.805,0,0,1-1.805-1.805A1.805,1.805,0,0,1-21.556-10h2.412a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1-19.144-6.39Z"
                                        transform="translate(23.361 10)"
                                    />
                                </g>
                                <g id="g841" transform="translate(67.771 44.738)">
                                    <path
                                        id="path843"
                                        d="M-19.144-6.39h-2.412a1.805,1.805,0,0,1-1.805-1.805A1.805,1.805,0,0,1-21.556-10h2.412a1.805,1.805,0,0,1,1.805,1.805A1.805,1.805,0,0,1-19.144-6.39Z"
                                        transform="translate(23.361 10)"
                                    />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <p className="mt-[6px]">Periodontist</p>
                </HashLink>
                <HashLink className="flex flex-col justify-between items-center"
                    to="/treatment/endodontists"
                >
                    <svg
                        fill="#35373A"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-[28%] mt-[1%]"
                        viewBox="0 0 113.828 113.826"
                    >
                        <g id="Layer_10" data-name="Layer 10" transform="translate(0)">
                            <path
                                id="Path_37937"
                                data-name="Path 37937"
                                d="M114.825,30.375a29.363,29.363,0,0,0-57.26-9.17,30.683,30.683,0,0,0-12.5,2.789,31.154,31.154,0,0,0-16.657-2.57,31.478,31.478,0,0,0-27.171,27.1A31.156,31.156,0,0,0,4.05,65.807,66.207,66.207,0,0,1,8.823,78.4l7.1,28.4a10.593,10.593,0,0,0,20.163,1.232l5.7-14.825a3.51,3.51,0,0,1,6.552,0l5.7,14.823A10.593,10.593,0,0,0,74.2,106.8l7.1-28.39a66.244,66.244,0,0,1,4.773-12.6,30.813,30.813,0,0,0,2.188-6.209,29.409,29.409,0,0,0,26.561-29.231ZM77.741,77.52l-7.1,28.392a6.921,6.921,0,0,1-13.174.8l-5.7-14.825a7.18,7.18,0,0,0-13.4,0l-5.7,14.825a6.919,6.919,0,0,1-13.172-.8l-7.1-28.39a69.812,69.812,0,0,0-5.027-13.3A27.468,27.468,0,0,1,4.883,48.968a27.762,27.762,0,0,1,23.967-23.9,27.463,27.463,0,0,1,15.408,2.6,1.819,1.819,0,0,0,1.608,0,27.213,27.213,0,0,1,10.742-2.767A29.258,29.258,0,0,0,84.453,59.7a27.239,27.239,0,0,1-1.687,4.527,69.846,69.846,0,0,0-5.025,13.3Zm8.471-58.16,1.076-1.076,1.076,1.076-1.076,1.076Zm8.261,11.933,4.748-4.748,1.994,1.994-4.748,4.748Zm-2.6-2.6-3.83-3.83,4.748-4.748,3.83,3.83Zm-2.754,2.438,2.912,2.912-2.06,2.06a9.117,9.117,0,0,0-2.688,6.49v6.137H83.616V41.965a12.767,12.767,0,0,1,3.763-9.086Zm-5.508,21.27h3.672v3.578c-.61.044-1.215.094-1.836.094s-1.226-.05-1.836-.094Zm7.343,3.062V42.6A5.544,5.544,0,0,1,92.571,38.7l2.06-2.06.538.538a1.836,1.836,0,0,0,2.6,0l7.343-7.343a1.836,1.836,0,0,0,0-2.6L94.093,16.226a1.836,1.836,0,0,0-2.6,0l-.538.538L88.585,14.39a1.836,1.836,0,0,0-2.6,0l-.538.538-2.374-2.374-2.6,2.6,2.374,2.374-.538.538a1.836,1.836,0,0,0,0,2.6l2.374,2.374-.538.538a1.836,1.836,0,0,0,0,2.6l2.374,2.374-1.744,1.744a16.411,16.411,0,0,0-4.839,11.682v13.5a25.7,25.7,0,1,1,11.015,0Z"
                                transform="translate(-0.998 -0.999)"
                            />
                            <path
                                id="Path_37938"
                                data-name="Path 37938"
                                d="M6,39.673H9.672A18.379,18.379,0,0,1,28.03,21.315V17.643A22.054,22.054,0,0,0,6,39.673Z"
                                transform="translate(3.184 12.914)"
                            />
                            <path
                                id="Path_37939"
                                data-name="Path 37939"
                                d="M0,0H3.672V5.192H0Z"
                                transform="translate(73.968 8.652) rotate(-45)"
                            />
                            <path
                                id="Path_37940"
                                data-name="Path 37940"
                                d="M40,8h5.508v3.672H40Z"
                                transform="translate(31.603 4.854)"
                            />
                        </g>
                    </svg>
                    <p className="mt-[6px]">Endodontist</p>
                </HashLink>
            </div >
        <div className=" flex items-center justify-center px-5 py-[3%]">
            <div className="max-w-screen-2xl w-full h-auto ">
                {treatments.map(({ data }) => (
                    <div
                        //   key={id}
                        //   id={id}
                        className=" lg:grid lg:grid-cols-3 text-[#35373a]  tracking-wider py-[6%] flex flex-col items-center justify-center lg:items-start"
                    >
                        <div className="col-span-1 w-full text-start lg:text-start">
                            {/* <p className='text-[90px] font-bold'>{data.title}</p> */}
                            <p className="lg:text-6xl md:text-5xl text-3xl font-bold">{data.title}</p>
                            <p className="lg:text-2xl md:text-2xl font-bold mb-[4%]">
                                {data.subTitle}
                            </p>
                            <img src={data.img} alt={data.title} />
                        </div>
                        <div className="col-span-2 lg:px-[12%] md:px-[8%] px-[1%] mt-[5%] lg:mt-0">
                            <p className="text-start mt-[5%] lg:mt-0 tracking-widest md:text-base text-sm">
                                {data.des}
                            </p>
                            <ul className="mt-[3%] custom-list">
                                <p className="md:text-xl text-lg font-bold mb-[3%] text-start lg:text-start ">
                                    SERVICES OFFERED
                                </p>
                                {data.services.map((service, index) => (
                                    <li
                                        key={index}
                                        className="cursor-pointer tracking-widest md:text-base text-sm"
                                    //   variants={listItemAnimation}
                                    //   initial="rest"
                                    //   whileHover="hover"
                                    >
                                        {service}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
                <div className="md:text-lg text-[#35373a] text-start">
                    <p>
                        We can't wait to meet you and help you achieve the smile of your
                        dreams! Whether you need a routine checkup or specialized dental
                        treatment, our expert team is here to provide you with
                        compassionate care and outstanding results. Contact us today to
                        schedule your appointment and experience the difference at our
                        clinic. Your healthiest, happiest smile is just a visit away!
                    </p>
                </div>
            </div>
        </div>
        </div >
    )
}
